import api from './api';

const profilePath = (id) => `/accounts/${encodeURIComponent(id)}/telegram-profile`;

const accountProfileService = {
  get: async (id) => (await api.get(profilePath(id))).data.data,
  update: async (id, profile) => (await api.patch(profilePath(id), profile)).data.data,
};

export default accountProfileService;
